import React, { useState } from "react";
import QrScanner from "react-qr-scanner";
import { useNavigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebaseConfig";

const ScanTicket = () => {
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleScan = async (data) => {
    if (data) {
      const scannedId = data.text || data; // handle both object and string
      try {
        const docRef = doc(db, "ticketPurchases", scannedId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          // ✅ Redirect to registration with the ticket ID
          navigate(`/register-ticket?id=${scannedId}`);
        } else {
          setError("❌ Ticket not found. Please try again or check manually.");
        }
      } catch (err) {
        console.error("Error validating ticket:", err);
        setError("⚠️ Error validating the ticket.");
      }
    }
  };

  const handleError = (err) => {
    console.error("QR Scan Error:", err);
    setError("⚠️ Unable to access camera.");
  };

  return (
    <div style={{ textAlign: "center", paddingTop: "40px" }}>
      <h2>Scan Ticket QR Code</h2>
      <div style={{ maxWidth: "400px", margin: "auto" }}>
        <QrScanner
          delay={500}
          style={{ width: "100%" }}
          onError={handleError}
          onScan={handleScan}
        />
      </div>
      {error && <p style={{ color: "red", marginTop: "20px" }}>{error}</p>}
    </div>
  );
};

export default ScanTicket;
